import React, { useEffect, useRef, useState } from 'react';
import s from './Modal.module.scss';
import { clsx } from '../../utils';

const STORAGE_KEY = '__MODAL_Z_STACK__';
const BASE_Z_INDEX = 1000;

/* -----------------------------
   Session Storage Helpers
------------------------------ */
const getStack = () => {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || [];
  } catch {
    return [];
  }
};

const setStack = (stack) => {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stack));
};

const acquireZIndex = () => {
  const stack = getStack();
  const nextZ = stack.length ? Math.max(...stack) + 1 : BASE_Z_INDEX + 1;
  stack.push(nextZ);
  setStack(stack);
  return nextZ;
};

const releaseZIndex = (zIndex) => {
  if (!zIndex) return;
  const stack = getStack().filter((z) => z !== zIndex);
  setStack(stack);
};

/* -----------------------------
   Modal Component
------------------------------ */
const Modal = ({ children, isOpen, isFullScreen = true }) => {
  const [mounted, setMounted] = useState(false);
  const zIndexRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      zIndexRef.current = acquireZIndex();
      setMounted(true);

      // Lock background scroll
      document.body.style.overflow = 'hidden';

      // Start animation in next frame (prevents flash)
    } else {
      setMounted(false);
      releaseZIndex(zIndexRef.current);
      zIndexRef.current = null;

      // Restore background scroll
      document.body.style.overflow = '';
    }
  }, [isOpen]);
  useEffect(() => {
    return () => {
      releaseZIndex(zIndexRef.current);
      zIndexRef.current = null;
    };
  }, []);

  if (!mounted) return null;

  return (
    <div
      className={clsx(s.overlayContainer, !isFullScreen && s.nonFullScreen)}
      style={{ zIndex: zIndexRef.current }}
    >
      <div className={clsx(s.modalContainer)}>
        <div className={s.modalContent}>{children}</div>
      </div>
    </div>
  );
};

export default Modal;
